import { render, staticRenderFns } from "./WaitRecv.vue?vue&type=template&id=180b218f&scoped=true&"
import script from "./WaitRecv.vue?vue&type=script&lang=js&"
export * from "./WaitRecv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180b218f",
  null
  
)

export default component.exports